import { createReducer, on } from '@ngrx/store';
import { ICompanyFormState, initialCompanyFormState } from '../states/company-form.state';
import { setActiveCompany, setTabYear, clearCompanyCache, setCompanyCode, setCompanyName, setCompanyCountry, setDefaultYear, loadInactivePeriodsSuccess, loadInactivePeriodsFailure } from '../actions/company-form.actions';

export const companyFormReducers = createReducer(
    initialCompanyFormState,

    on(setActiveCompany, (state, { companyId }) => {
        if (state.companyId === companyId) {
            return state;
        }
        return {
            ...initialCompanyFormState,
            companyId
        };
    }),

    on(setTabYear, (state, { tabId, year }) => ({
        ...state,
        tabs: {
            ...state.tabs,
            [tabId]: { ...state.tabs[tabId], year }
        }
    })),

    on(clearCompanyCache, () => ({
        ...initialCompanyFormState
    })),

    on(setCompanyCode, (state, { companyCode }) => ({
        ...state,
        companyCode
    })),

    on(setCompanyName, (state, { companyName }) => ({
        ...state,
        companyName
    })),

    on(setCompanyCountry, (state, { companyCountry }) => ({
        ...state,
        companyCountry
    })),

    on(setDefaultYear, (state, { year }) => ({
        ...state,
        defaultYear: year
    })),

    on(loadInactivePeriodsSuccess, (state, { inactivePeriods }) => ({
        ...state,
        inactivePeriods,
        inactivePeriodsLoaded: true
    })),

    on(loadInactivePeriodsFailure, (state) => ({
        ...state,
        inactivePeriods: [],
        inactivePeriodsLoaded: true
    }))
);
